import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Portfolio from '../components/Portfolio';

function PortfolioPage() {
  return (
    <>
      <PageHero
        label="Corporate Structure"
        title="Nexus Concordat, Inc."
        subtitle="Parent holding company. Two Delaware C-corp subsidiaries below. IP portfolio held at the parent level."
      />
      <BackButton />
      <Portfolio />
    </>
  );
}

export default PortfolioPage;
